const triggerUserSetEvent = (): void => {
  window.dataLayer?.push({ event: 'product-fruits-user-set' })
}

export default triggerUserSetEvent
